export const  firebaseConfig = {
    apiKey: "AIzaSyA1g576DQ1-M2alMpbNOGIh-amrsP2i--U",
    authDomain: "red-onion-foods-52ba8.firebaseapp.com",
    databaseURL: "https://red-onion-foods-52ba8.firebaseio.com",
    projectId: "red-onion-foods-52ba8",
    storageBucket: "red-onion-foods-52ba8.appspot.com",
    messagingSenderId: "230726382859",
    appId: "1:230726382859:web:7ebbf93dfc934404061e0e"
  };